import { defineMessages } from "react-intl";

export const scope = "app.containers.LandingPage";

export default defineMessages({
  s1: {
    advance_your: {
      id: `${scope}.s1.advance_your`,
      defaultMessage: `The Decentralized Multi-chain`,
    },
    crypto_assets: {
      id: `${scope}.s1.crypto_assets`,
      defaultMessage: `Fund Management Protocol`,
    },
    detail: {
      id: `${scope}.s1.detail`,
      defaultMessage: `Definix is the transparent crypto investment platform on DeFi that helps crypto investors to invest confidently and allows professional traders to earn more from their investing skill by creating and managing their own funds.`,
    },
  },
  s2: {
    definix_is: {
      id: `${scope}.s2.definix_is`,
      defaultMessage: `Definix is`,
    },
    the_best_choice: {
      id: `${scope}.s2.the_best_choice`,
      defaultMessage: `the best choice`,
    },
    for: {
      id: `${scope}.s2.for`,
      defaultMessage: `for`,
    },
    non_crypto: {
      id: `${scope}.s2.non_crypto`,
      defaultMessage: `Crypto investors`,
    },
    non_crypto2: {
      id: `${scope}.s2.non_crypto2`,
      defaultMessage: `who want to start investing in crypto assets tradable in liquidity mining, crypto managed-fund.`,
    },
    pro_trader: {
      id: `${scope}.s2.pro_trader`,
      defaultMessage: `Professional traders`,
    },
    pro_trader2: {
      id: `${scope}.s2.pro_trader2`,
      defaultMessage: `who want to have their own crypto fund be the manager on our platform, and incentivized from performance and management fees.`,
    },
    pro_trader2_bracket: {
      id: `${scope}.s2.pro_trader2_bracket`,
      defaultMessage: `Participants must pass the Finix Challenge, a paper trade on chain.`,
    },
  },
  s3: {
    liquidity_title: {
      id: `${scope}.s3.liquidity_title`,
      defaultMessage: `Liquidity Providing & Farming`,
    },
    liquidity_info: {
      id: `${scope}.s3.liquidity_info`,
      defaultMessage: `For crypto investors, trading cryptocurrencies is difficult and very risky. Liquidity providing & farming are much more friendly for new comers. Definix has various pools and farms with fruitful return as lower risk choices to start growing crypto assets. Provided liquidity will be fuels to the decentralized exchange on the platform.`,
    },
    invest_title: {
      id: `${scope}.s3.invest_title`,
      defaultMessage: `Invest Confidently in Professional Managed Funds`,
    },
    invest_info: {
      id: `${scope}.s3.invest_info`,
      defaultMessage: `No worries if you don’t know that much to make profits from crypto trading. You can invest in crypto funds managed by professional traders. With helps from experts, your portfolio is likely to grow easier.`,
    },
    user_title: {
      id: `${scope}.s3.user_title`,
      defaultMessage: `User-Generated Crypto Funds`,
    },
    user_info: {
      id: `${scope}.s3.user_info`,
      defaultMessage: `For high-skilled traders, they can come to challenge our test.  If they pass, they can create their own funds on the platform and earn more from fund managing fees.`,
    },
  },
  s4: {
    hello_to: {
      id: `${scope}.s4.hello_to`,
      defaultMessage: `Say hello to`,
    },
    definix_v1: {
      id: `${scope}.s4.definix_v1`,
      defaultMessage: `Definix G1`,
    },
    dex_title: {
      id: `${scope}.s4.dex_title`,
      defaultMessage: `DEX and Liquidity Pools`,
    },
    dex_info: {
      id: `${scope}.s4.dex_info`,
      defaultMessage: `Decentralized exchange (DEX) is a cryptocurrency exchange operated by smart contracts. You can start exchange by just connecting your favorite crypto wallet to the platform. Also, you can provide liquidity to liquidity pool here to get LP token.`,
    },
    coming_soon: {
      id: `${scope}.s4.coming_soon`,
      defaultMessage: `Coming soon`,
    },
    farm_title: {
      id: `${scope}.s4.farm_title`,
      defaultMessage: `Farms`,
    },
    farm_info: {
      id: `${scope}.s4.farm_info`,
      defaultMessage: `You can farm your LP tokens here to get tokens as a return of your investment. There are many farms available for choosing.`,
    },
    invest_title: {
      id: `${scope}.s4.invest_title`,
      defaultMessage: `Crypto Fund Investment`,
    },
    invest_info: {
      id: `${scope}.s4.invest_info`,
      defaultMessage: `The system will evaluate your risk tolerance and suggest the right crypto funds for you. All of listed funds are managed by professional traders.`,
    },
    pro_title: {
      id: `${scope}.s4.pro_title`,
      defaultMessage: `For Professional Traders`,
    },
    pro_info: {
      id: `${scope}.s4.pro_info`,
      defaultMessage: `You can request for Finix trading challenge. If you win, you will be able set up your crypto fund on the platform and earn from managing fees.`,
    },
  },
  s5: {
    overview: {
      id: `${scope}.s5.overview`,
      defaultMessage: `Overview`,
    },
    definix: {
      id: `${scope}.s5.definix`,
      defaultMessage: `Definix`,
    },
  },
  s6: {
    milestone: {
      id: `${scope}.s6.milestone`,
      defaultMessage: `Milestone`,
    },
    definix: {
      id: `${scope}.s6.definix`,
      defaultMessage: `Definix`,
    },
    q1: {
      list1: {
        id: `${scope}.s6.q1.list1`,
        defaultMessage: `Decentralized Exchange`,
      },
      list2: {
        id: `${scope}.s6.q1.list2`,
        defaultMessage: `Liquidity Pool`,
      },
      list3: {
        id: `${scope}.s6.q1.list3`,
        defaultMessage: `Liquidity Pool Farming`,
      },
    },
    q2: {
      list1: {
        id: `${scope}.s6.q2.list1`,
        defaultMessage: `Bridge to another blockchain`,
      },
      list2: {
        id: `${scope}.s6.q2.list2`,
        defaultMessage: `Crypto Fund Investment`,
      },
      list3: {
        id: `${scope}.s6.q2.list3`,
        defaultMessage: `Paper trade onchain`,
      },
    },
    q3: {
      list1: {
        id: `${scope}.s6.q3.list1`,
        defaultMessage: `Launch wallet application with simple investment`,
      },
      list2: {
        id: `${scope}.s6.q3.list2`,
        defaultMessage: `Connect to partner for multi-channel investment`,
      },
      list3: {
        id: `${scope}.s6.q3.list3`,
        defaultMessage: `Implement Dollar Cost Averaging (DCA)`,
      },
      list4: {
        id: `${scope}.s6.q3.list4`,
        defaultMessage: `Finix Challenge Fund`,
      },
    },
    q4: {
      list1: {
        id: `${scope}.s6.q4.list1`,
        defaultMessage: `More to be announce`,
      },
    },
  },
});
